export const snapshotKpi = {
  FINAL_KPI: "final-kpi",
  INITIAL_KPI: "initial-kpi",
};

export const clientVision = {
  CLIENT_VISION: "clientvision-com-cori",
};

export const liquidyInvest = {
  LIS: "salesben_lis",
};
